module.exports = __webpack_public_path__ + "img/teams-header@2x.d1d0affa.jpg";